import { FamiliarData } from './FamiliarData'

export interface FamiliarDataDTO {
  id: string
  userID: string
  information: string
  date: Date
}

export function fromModel(u: FamiliarData): FamiliarDataDTO {
  return {
    id: u.id,
    userID: u.userID,
    information: u.information,
    date: new Date(),
  }
}

export function toModel(d: FamiliarDataDTO): FamiliarData {
  return new FamiliarData(d)
}
